<template>
  <CardModule title="Equipamentos">
    <v-row>
      <v-col cols="12">
        <v-radio-group
          v-model="$pointOfSale.cadastro.equipamentos.rede_vendas"
          class="mt-0"
          hide-details
        >
          <template v-slot:label>
            <div class="">Rede de Vendas:</div>
          </template>
          <v-radio
            value="COMPARTILHADA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Rede Compartilhada<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="PRIVADA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Rede Exclusiva<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseAutocomplete
          label="Selecione os equipamentos"
          item-text="descricao"
          no-data-text="Nenhum equipamento encontrado"
          return-object
          hide-details
          multiple
          :search-input.sync="searchEquips"
          :items="$pointOfSale.lista_equipamentos"
          :filter="searchEquip"
          v-model="$pointOfSale.cadastro.equipamentos.equipamentos_array"
          @change="clearInput"
        >
          <template v-slot:selection="{ item }">
            {{ item.descricao }} {{ item.is_app ? "(App)" : "" }},
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="isPrivatedStore">
        <BaseAutocomplete
          label="Selecione a loja"
          item-text="nome_loja"
          item-value="sequenciador"
          type="text"
          hide-details
          autocomplete="false"
          :items="$loja_gerenciar.lojas"
          :filter="search"
          v-model="$pointOfSale.cadastro.equipamentos.selectedStore"
        >
          <template v-slot:selection="{ item }">
            <div v-if="item ? (lojas = item) : null">
              {{ lojas.nome_loja }}
            </div>
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row v-if="!hasSupervisorPassword">
      <v-col cols="12">
        <BaseTextField
          label="Senha do Supervisor"
          placeholder="Digite a senha do supervisor"
          autocomplete="new-password"
          name="supervisorPassword"
          :rules="[rules.required, rules.min(6)]"
          v-model="$pointOfSale.cadastro.equipamentos.supervisorPassword"
          :type="typeSupervisorPass"
          :append-icon="showSupervisorPasswordIcon"
          @click:append="showSupervisorPass = !showSupervisorPass"
        />
      </v-col>
    </v-row>
    <v-row v-if="hasSupervisorPassword">
      <v-col cols="12">
        <BaseTextField
          label="Senha antiga"
          placeholder="Digite a senha antiga"
          autocomplete="new-password"
          name="oldPassword"
          hide-details
          v-model="$pointOfSale.cadastro.equipamentos.oldPassword"
          :type="typeOldPassword"
          :append-icon="showOldPasswordIcon"
          @click:append="showOldPass = !showOldPass"
        />
      </v-col>
    </v-row>
    <v-row v-if="hasSupervisorPassword">
      <v-col cols="12">
        <BaseTextField
          label="Senha nova"
          placeholder="Digite a nova senha"
          autocomplete="new"
          name="newPassword"
          hide-details
          v-model="$pointOfSale.cadastro.equipamentos.newPassword"
          :type="typeNewPassword"
          :append-icon="showNewPasswordIcon"
          @click:append="showNewPass = !showNewPass"
        />
      </v-col>
    </v-row>
    <v-row v-if="hasSupervisorPassword">
      <v-col cols="12">
        <BaseTextField
          label="Confirme a senha"
          placeholder="Confirme a nova senha"
          autocomplete="new"
          name="newPassword"
          v-model="$pointOfSale.cadastro.equipamentos.confirmPassword"
          :hide-details="!passwordCheck"
          :error="passwordCheck"
          hint="As senhas não conferem"
          :type="typeNewPasswordConfirm"
          :append-icon="showNewPasswordIconConfirm"
          @click:append="showNewPassConfirm = !showNewPassConfirm"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import PDVmixins from "@/mixins/PDV.mixins.js";
import formRules from "@/mixins/formRules";
export default {
  name: "Equipments",
  mixins: [PDVmixins, formRules],
  components: {
    CardModule,
    BaseTextField,
    BaseAutocomplete,
  },
  data() {
    return {
      searchEquips: "",
      showOldPass: false,
      showNewPass: false,
      showNewPassConfirm: false,
      showSupervisorPass: false,
    };
  },
  computed: {
    passwordCheck() {
      return this.$pointOfSale.cadastro.equipamentos.newPassword !== "" &&
        this.$pointOfSale.cadastro.equipamentos.confirmPassword !== ""
        ? this.$pointOfSale.cadastro.equipamentos.newPassword !==
            this.$pointOfSale.cadastro.equipamentos.confirmPassword
        : false;
    },
    isPrivatedStore() {
      return this.$pointOfSale.cadastro.equipamentos.rede_vendas === "PRIVADA";
    },
    hasSupervisorPassword() {
      return (
        this.$pointOfSale.actionType === "editar" &&
        this.$pointOfSale.cadastro.equipamentos.hasSupervisorPass
      );
    },
    typeOldPassword() {
      return this.showOldPass ? "text" : "password";
    },
    showOldPasswordIcon() {
      const { view, viewOff } = this.$config.icons;
      return this.showOldPass ? viewOff : view;
    },
    typeNewPassword() {
      return this.showNewPass ? "text" : "password";
    },
    showNewPasswordIcon() {
      const { view, viewOff } = this.$config.icons;
      return this.showNewPass ? viewOff : view;
    },
    typeNewPasswordConfirm() {
      return this.showNewPass ? "text" : "password";
    },
    showNewPasswordIconConfirm() {
      const { view, viewOff } = this.$config.icons;
      return this.showNewPass ? viewOff : view;
    },
    typeSupervisorPass() {
      return this.showSupervisorPass ? "text" : "password";
    },
    showSupervisorPasswordIcon() {
      const { view, viewOff } = this.$config.icons;
      return this.showSupervisorPass ? viewOff : view;
    },
  },
  methods: {
    clearInput() {
      this.searchEquips = "";
    },
    replaceSpecialChars(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[èèêë]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str
        .toString()
        .normalize("NFD")
        .replace(/[^a-zA-Zs]/g, "");
      str = str.replace(" ", "-");

      return str;
      // return str.replace(/[^a-z0-9]/gi,'-');
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchEquip(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  watch: {
    "$pointOfSale.cadastro.equipamentos.equipamentos_array"(e) {
      let is_app = [];
      if (e.length >= 1) {
        e.forEach(equip => {
          if (equip.is_app) {
            this.$pointOfSale.cadastro.equipamentos.link_venda =
              equip.link_vendas;
            is_app.push(equip);
          }
        });
      } else if (e.length == 0) {
        this.$pointOfSale.cadastro.equipamentos.link_venda = "";
      }

      if (is_app.length > 1) {
        this.$config.alert(
          "Atenção! Não é possível selecionar mais de um equipamento do tipo APP",
          this.$config.dados.errorColor
        );

        e.forEach((equip, index) => {
          is_app.find(item => {
            if (equip.idequipamento == item.idequipamento) {
              this.$pointOfSale.cadastro.equipamentos.equipamentos_array.splice(
                index,
                1
              );
            }
          });
        });
      }
    },
  },
  created() {
    if (this.$route.path === "/pessoas/ponto-de-venda/cadastrar") {
      this.$pointOfSale.cadastro.equipamentos.rede_vendas = "COMPARTILHADA";
    }
  },
  beforeMount() {
    this.$pointOfSale.cadastro.equipamentos.rede_vendas_old =
      this.$pointOfSale.cadastro.equipamentos.rede_vendas;
    this.$loja_gerenciar.getAllLojas();
    this.$axios.setLocal("lojas", this.$lojas_usuarios.lojas);
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
